// Function that simulates fetching a permission from remote server
const fetchPermission = (user) => async (permission) => {
    // Simulate a delay from a request

    await new Promise(resolve => setTimeout(resolve, 1000));
    return user.permissions.includes(permission);
}
export default fetchPermission;